// Shared tour infrastructure
export { TourContext } from './context/TourContext';
export { TourProvider } from './context/TourProvider';
export { useTour } from './hooks/useTour';
export { useTourAutoAdvance } from './hooks/useTourAutoAdvance';
export { TourHighlight } from './components/TourHighlight';
export { TOUR_REGISTRY } from './registry';
export type { TourStep, TourStepType, TourState, TourActions, TourContextValue, TourDefinition } from './types';

// AdminTour (guided product walkthrough)
export { AdminTourOverlay, AdminTourAutoStart } from './AdminTour';
export type { AdminTourStepId } from './AdminTour';
export { ADMIN_TOUR_STEPS, REQUIRED_HOTSPOTS } from './AdminTour';

// TemplatesTour
export { TemplatesTourOverlay } from './TemplatesTour';

// AssignmentsTour
export { AssignmentsTourOverlay } from './AssignmentsTour';

// TagsTour
export { TagsTourOverlay } from './TagsTour';

// RegistrationTour
export { RegistrationTourOverlay } from './RegistrationTour';

// EoGuardrailsTour
export { EoGuardrailsTourOverlay } from './EoGuardrailsTour';

// LoggingTour
export { LoggingTourOverlay } from './LoggingTour';

// ContactManagementTour
export { ContactManagementTourOverlay } from './ContactManagementTour';

// WhySmsTour
export { WhySmsTourOverlay } from './WhySmsTour';

// ConversationMgmtTour
export { ConversationMgmtTourOverlay } from './ConversationMgmtTour';

// WhyVoleyTour
export { WhyVoleyTourOverlay } from './WhyVoleyTour';
